import React from "react";
import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  Divider,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import Calc from "./calc";
import bgImage from "./img/apex-s4-bg.jpg";
import "./App.css";
import { COLORS } from "./types";

const theme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: COLORS.RED,
    },
    secondary: {
      main: COLORS.HEIRLOOM,
    },
  },
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: COLORS.RED,
      },
    },
  },
});

const useStyles = makeStyles({
  root: {
    backgroundImage: `url(${bgImage})`,
    backgroundColor: "#101010",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    position: "relative",
    color: "#fff",
    padding: `${64 + 18}px 0px 1em`,
    transform: "translate3d(0, 0, 0)",
  },
  version: {
    opacity: 0.5,
    marginLeft: 9,
  },
});

function App() {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={`${classes.root} App`}>
        <AppBar className={classes.appBar} position="absolute">
          <Toolbar>
            <Typography variant="h6" style={{ lineHeight: "1.1em" }}>
              Apex Packs Calculator
            </Typography>
            <Typography className={classes.version} variant="caption">
              S13 (v1.2.2)
            </Typography>
          </Toolbar>
        </AppBar>

        <Calc />

        <div style={{ marginTop: "2rem" }}>
          <Divider />
          <Typography
            style={{
              marginTop: 24,
              color: "#666",
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }}
            variant="caption"
            paragraph={true}
          >
            &copy; {new Date().getFullYear()} Mike Zarandona (TheMikeZ on XBL)
          </Typography>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
